import { useReducer, useEffect } from 'react';

/**
 * Provides a key to be used on a React element to force a reload an entire React app.
 * This allows React to re-mount when bfcaches try to skip the React lifecycle
 * @return {key: Number}
 */
const useForceReloadApp = () => {
    const [key, forceUpdate] = useReducer((x) => x + 1, 0);

    // Without this event listener, React code on previously visited page won't run again when browser back button clicked.
    useEffect(() => {
        const reloadApp = (event) => {
            // Check if the page is loaded from the bfcache
            if (event.persisted) {
                forceUpdate();
            }
        };

        window.addEventListener('pageshow', reloadApp);
        return () => {
            window.removeEventListener('pageshow', reloadApp);
        };
    }, []);

    return key;
};

export default useForceReloadApp;
